export default __webpack_public_path__ + "static/media/2.6d68c1c7.jpg";